import { createAsyncThunk } from '@reduxjs/toolkit';
import { tuitionApi } from '~/apis/tuition';
import { CREATE_TUITION, DELETE_TUITION_BY_ID, GET_LIST_TUITION, GET_TUITION_BY_ID, UPDATE_TUITION } from '~/utils/constants/actionType';
import { IBodyCreateTuition, IBodyUpdateTuition, IQueryGetTuitions } from '~/utils/interface/tuition';

export const getListTuitions = createAsyncThunk(
  GET_LIST_TUITION,
  async (payload: IQueryGetTuitions, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.getListTuitions(payload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTuition = createAsyncThunk(
  CREATE_TUITION,
  async (payload: IBodyCreateTuition, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.createTuition(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateTuition = createAsyncThunk(
  UPDATE_TUITION,
  async (payload: { tuitionId: string; body: IBodyUpdateTuition }, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.updateTuition(payload.tuitionId, payload.body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTuitionById = createAsyncThunk(
  GET_TUITION_BY_ID, 
  async (tuitionId: string, { rejectWithValue }) => {
  try {
    const res = await tuitionApi.getTuitionById(tuitionId);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteTuitionById = createAsyncThunk(
  DELETE_TUITION_BY_ID,
  async (tuitionId: string, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.deleteTuitionById(tuitionId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);